var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{ref:"chart",attrs:{"id":"histogram"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }